import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ApiPost } from "../../../../helpers/API/ApiData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../../_metronic/_assets/sass/layout/_basic.scss";
import homepageicon from "../../../../assets/images/logintitle.png";
import weprologinlogo from "../../../../assets/images/weprologologin.png";
import Logo from "../../../../assets/icon/logo.svg"
import weprologinskatch from "../../../../assets/images/weprologontitle.png";
import * as userUtil from "../../../../utils/user.util";
import * as authUtil from "../../../../utils/auth.util";

export default function Login() {
  const history = useHistory();
  const [loginData, setLoginData] = useState({});
  const [errors, setErrors] = useState({});
  const [bool, setBool] = useState({ loader: false });
  const [showPassword, setShowPassword] = useState(false);
  const regexEmail =/^(([^<>()[\],;:\s@]+([^<>()[\],;:\s@]+)*)|(.+))@(([^<>()[\],;:\s@]+)+[^<>()[\],;:\s@]{2,})$/i;

  const handleChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const onFormSubmit = (e) => {
    e.preventDefault();
  };

  const handleSubmit = async (e) => {
    setBool({ ...bool, loader: true });
    e.preventDefault();

    if (!loginData.emailId && !loginData.password) {
      setErrors({
        emailId: "Email is required*",
        password: "Password is required*",
        roleId: "6316d71dec63d255184b332c",
      });
    } else if (loginData.emailId === "" && loginData.password === "") {
      setErrors({ ...errors, emailId: "Email is required*" });
    } else if (!loginData.emailId || loginData.emailId === "") {
      setErrors({ ...errors, emailId: "Email is required*" });
    } else if (
      !loginData.emailId ||
      regexEmail.test(loginData.emailId) === false
    ) {
      setErrors({ ...errors, emailId: "Email is not valid*" });
    } else if (!loginData.password || loginData.password === "") {
      setErrors({ ...errors, password: "Password is required*" });
    } else {
      loginData.emailId = loginData.emailId.toLowerCase();
      const body = {
        email: loginData.emailId.toLowerCase(),
        password: loginData.password,
      };

      await ApiPost("user/adminSignin", body)
        .then((res) => {
          if (res?.status === 200) {
            if (res?.data?.payload?.role == "user") {
              toast.error("Nicht gefunden");
            } else if (res?.data?.payload?.role == "vattenfallAdmin") {
              authUtil.set2FA(false);
              authUtil.setToken(res?.data?.payload?.token);
              userUtil.setUserInfo(res?.data?.payload);
              setTimeout(() => {
                history.push("/dashboard");
                window.location.reload();
              }, 100);
            } else {
              localStorage.setItem("email", loginData.emailId);
              history.push("/auth/google-login");
            }
          }
        })
        .catch((error) => {
          toast.error(
            error.response?.data?.message
              ? error.response?.data?.message
              : "Oops something wrong"
          );
        });
    }
    setBool({ ...bool, loader: false });
  };

  return (
    <>
      <div className="home-container">
        <div className="main-design-logo-flex">
          <img src={Logo} alt="logo" width={300} height={150}/>
          {/* <svg
            width="326"
            height="92"
            viewBox="0 0 163 46"
            fill="#000000"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.37031 17.1153C3.55405 27.6509 27.7709 34.1411 16.814 31.4792C5.8572 28.8173 -2.25323 20.8036 0.563079 10.268C3.37938 -0.267689 24.9582 -1.45019 35.9151 1.21166C46.8719 3.87353 9.18663 6.5796 6.37031 17.1153Z"
              fill="url(#paint0_linear_1413_2214)"
            />
            <path
              d="M25.1686 25.9534L20.8516 13.3153H22.2418L26.2844 25.2132H25.5894L29.76 13.3153H31.0038L35.1197 25.2132H34.4612L38.5403 13.3153H39.8392L35.522 25.9534H34.0953L30.1625 14.6693H30.5282L26.577 25.9534H25.1686ZM43.5283 18.9663H50.2966V20.1038H43.5283V18.9663ZM43.6747 24.7979H51.3759V25.9534H42.3211V13.3153H51.1014V14.4708H43.6747V24.7979ZM54.5576 25.9534V13.3153H59.3504C60.4357 13.3153 61.3685 13.4898 62.149 13.8389C62.9294 14.1759 63.527 14.6693 63.9417 15.3194C64.3685 15.9573 64.582 16.7337 64.582 17.6484C64.582 18.539 64.3685 19.3094 63.9417 19.9593C63.527 20.5972 62.9294 21.0908 62.149 21.4397C61.3685 21.7889 60.4357 21.9633 59.3504 21.9633H55.3076L55.9113 21.3314V25.9534H54.5576ZM55.9113 21.4397L55.3076 20.7898H59.3137C60.5942 20.7898 61.5637 20.519 62.2222 19.9774C62.893 19.4237 63.2283 18.6473 63.2283 17.6484C63.2283 16.6374 62.893 15.8549 62.2222 15.3012C61.5637 14.7476 60.5942 14.4708 59.3137 14.4708H55.3076L55.9113 13.8389V21.4397ZM67.5089 25.9534V13.3153H72.3016C73.3871 13.3153 74.3197 13.4898 75.1001 13.8389C75.8811 14.1759 76.4785 14.6693 76.8929 15.3194C77.3196 15.9573 77.5333 16.7337 77.5333 17.6484C77.5333 18.539 77.3196 19.3094 76.8929 19.9593C76.4785 20.5972 75.8811 21.0908 75.1001 21.4397C74.3197 21.7768 73.3871 21.9453 72.3016 21.9453H68.2592L68.8627 21.3314V25.9534H67.5089ZM76.2525 25.9534L72.9604 21.3675H74.4235L77.7347 25.9534H76.2525ZM68.8627 21.4397L68.2592 20.8078H72.2647C73.5455 20.8078 74.515 20.531 75.1738 19.9774C75.8442 19.4237 76.1795 18.6473 76.1795 17.6484C76.1795 16.6374 75.8442 15.8549 75.1738 15.3012C74.515 14.7476 73.5455 14.4708 72.2647 14.4708H68.2592L68.8627 13.8389V21.4397ZM86.3255 26.0617C85.3621 26.0617 84.4657 25.9053 83.6369 25.5923C82.8197 25.2673 82.1062 24.8159 81.4965 24.2382C80.8992 23.6484 80.4294 22.9683 80.0881 22.1981C79.7583 21.4157 79.5938 20.5612 79.5938 19.6343C79.5938 18.7076 79.7583 17.8589 80.0881 17.0887C80.4294 16.3062 80.8992 15.6263 81.4965 15.0486C82.1062 14.4587 82.8197 14.0074 83.6369 13.6944C84.4534 13.3695 85.3498 13.207 86.3255 13.207C87.2888 13.207 88.1791 13.3695 88.9963 13.6944C89.8135 14.0074 90.5208 14.4527 91.1182 15.0304C91.7279 15.6082 92.1976 16.2882 92.5267 17.0706C92.868 17.8529 93.0387 18.7076 93.0387 19.6343C93.0387 20.5612 92.868 21.4157 92.5267 22.1981C92.1976 22.9804 91.7279 23.6605 91.1182 24.2382C90.5208 24.8159 89.8135 25.2673 88.9963 25.5923C88.1791 25.9053 87.2888 26.0617 86.3255 26.0617ZM86.3255 24.8701C87.0942 24.8701 87.8015 24.7437 88.4474 24.4909C89.1062 24.2261 89.6729 23.8591 90.1487 23.3896C90.6362 22.9082 91.0144 22.3545 91.2827 21.7286C91.551 21.0908 91.6855 20.3925 91.6855 19.6343C91.6855 18.8761 91.551 18.184 91.2827 17.5581C91.0144 16.9202 90.6362 16.3665 90.1487 15.8971C89.6729 15.4157 89.1062 15.0486 88.4474 14.7958C87.8015 14.531 87.0942 14.3986 86.3255 14.3986C85.5574 14.3986 84.8439 14.531 84.1851 14.7958C83.527 15.0486 82.9535 15.4157 82.466 15.8971C81.9901 16.3665 81.6119 16.9202 81.332 17.5581C81.0637 18.184 80.9292 18.8761 80.9292 19.6343C80.9292 20.3806 81.0637 21.0726 81.332 21.7106C81.6119 22.3484 81.9901 22.9082 82.466 23.3896C82.9535 23.8591 83.527 24.2261 84.1851 24.4909C84.8439 24.7437 85.5574 24.8701 86.3255 24.8701ZM22.516 45.2114V32.5733H27.4551C28.821 32.5733 30.01 32.8502 31.0223 33.4038C32.0343 33.9455 32.8209 34.6917 33.3819 35.6426C33.9551 36.5814 34.2417 37.6647 34.2417 38.8924C34.2417 40.1201 33.9551 41.2094 33.3819 42.1603C32.8209 43.099 32.0343 43.8453 31.0223 44.399C30.01 44.9406 28.821 45.2114 27.4551 45.2114H22.516ZM23.1381 44.6518H27.4185C28.6747 44.6518 29.7661 44.405 30.6929 43.9116C31.632 43.418 32.3514 42.7379 32.8515 41.8713C33.3635 41.0048 33.6198 40.0118 33.6198 38.8924C33.6198 37.7729 33.3635 36.78 32.8515 35.9134C32.3514 35.0468 31.632 34.3667 30.6929 33.8733C29.7661 33.3797 28.6747 33.133 27.4185 33.133H23.1381V44.6518ZM38.141 38.5132H45.2019V39.0729H38.141V38.5132ZM38.2508 44.6518H46.2811V45.2114H37.6287V32.5733H46.025V33.133H38.2508V44.6518ZM54.7684 45.2837C53.2074 45.2837 51.9758 44.8323 51.0733 43.9296C50.1831 43.0268 49.7379 41.6787 49.7379 39.8853V32.5733H50.36V39.8673C50.36 41.5042 50.744 42.7259 51.5123 43.5323C52.2805 44.3267 53.3659 44.724 54.7684 44.724C56.1709 44.724 57.2561 44.3267 58.0244 43.5323C58.7926 42.7259 59.1769 41.5042 59.1769 39.8673V32.5733H59.7805V39.8853C59.7805 41.6787 59.3294 43.0268 58.427 43.9296C57.5366 44.8323 56.3171 45.2837 54.7684 45.2837ZM66.5181 45.2114V33.133H61.8168V32.5733H71.823V33.133H67.1217V45.2114H66.5181ZM77.2193 45.2837C76.2805 45.2837 75.3902 45.1212 74.5484 44.7961C73.7196 44.4592 73.0854 44.0379 72.6464 43.5323L72.9754 43.099C73.3899 43.5564 73.9756 43.9476 74.7314 44.2725C75.5002 44.5855 76.3228 44.742 77.2008 44.742C78.0911 44.742 78.823 44.6216 79.3958 44.3809C79.9693 44.1402 80.3898 43.8212 80.6582 43.424C80.9388 43.0148 81.0787 42.5634 81.0787 42.07C81.0787 41.4922 80.9326 41.0288 80.6404 40.6797C80.3475 40.3307 79.957 40.0539 79.4695 39.8493C78.9937 39.6447 78.4693 39.4762 77.8965 39.3437C77.3353 39.2114 76.7618 39.0729 76.1767 38.9284C75.6032 38.772 75.0728 38.5794 74.5853 38.3507C74.1094 38.1101 73.7258 37.7851 73.4329 37.3758C73.1523 36.9545 73.0123 36.4129 73.0123 35.7509C73.0123 35.1852 73.1646 34.6556 73.4697 34.1621C73.7742 33.6686 74.2501 33.2714 74.8959 32.9705C75.5425 32.6576 76.372 32.5012 77.3838 32.5012C78.0788 32.5012 78.7622 32.6094 79.4327 32.8261C80.1154 33.0308 80.695 33.3075 81.1702 33.6567L80.8964 34.1441C80.3837 33.771 79.817 33.4941 79.1951 33.3136C78.5731 33.1331 77.9757 33.0427 77.4022 33.0427C76.5488 33.0427 75.8354 33.1691 75.2619 33.4219C74.7014 33.6626 74.2863 33.9876 74.018 34.3969C73.7496 34.8061 73.6158 35.2574 73.6158 35.7509C73.6158 36.3407 73.7619 36.8101 74.0548 37.1592C74.347 37.5081 74.7314 37.7851 75.2073 37.9897C75.6947 38.1943 76.2252 38.3628 76.7987 38.4952C77.3715 38.6276 77.945 38.772 78.5185 38.9284C79.0913 39.0729 79.6156 39.2656 80.0915 39.5062C80.579 39.747 80.9633 40.0719 81.2439 40.4812C81.5361 40.8783 81.6829 41.402 81.6829 42.0519C81.6829 42.6176 81.5238 43.1472 81.2071 43.6406C80.9019 44.1342 80.4144 44.5313 79.744 44.8323C79.0851 45.1332 78.244 45.2837 77.2193 45.2837ZM90.3262 45.2837C89.3875 45.2837 88.5156 45.1272 87.7107 44.8142C86.9058 44.4893 86.2046 44.0379 85.6066 43.4601C85.0092 42.8824 84.5456 42.2083 84.2165 41.438C83.8874 40.6557 83.7229 39.8071 83.7229 38.8924C83.7229 37.9776 83.8874 37.1351 84.2165 36.3648C84.5456 35.5824 85.0092 34.9024 85.6066 34.3246C86.2046 33.7469 86.9058 33.3015 87.7107 32.9886C88.5156 32.6636 89.3875 32.5012 90.3262 32.5012C91.1919 32.5012 92.0092 32.6395 92.7772 32.9164C93.546 33.1932 94.2103 33.6145 94.7715 34.1801L94.3871 34.5773C93.8143 34.0358 93.1862 33.6506 92.5028 33.4219C91.8323 33.1812 91.1127 33.0608 90.3447 33.0608C89.4906 33.0608 88.6979 33.2112 87.9667 33.5122C87.2348 33.801 86.5945 34.2103 86.0455 34.7399C85.5096 35.2694 85.0884 35.8894 84.7839 36.5994C84.491 37.2975 84.3449 38.0619 84.3449 38.8924C84.3449 39.7228 84.491 40.4932 84.7839 41.2033C85.0884 41.9015 85.5096 42.5152 86.0455 43.0448C86.5945 43.5744 87.2348 43.9897 87.9667 44.2907C88.6979 44.5795 89.4906 44.724 90.3447 44.724C91.1127 44.724 91.8323 44.6096 92.5028 44.3809C93.1862 44.1402 93.8143 43.7429 94.3871 43.1893L94.7715 43.5865C94.2103 44.1522 93.546 44.5795 92.7772 44.8684C92.0092 45.1452 91.1919 45.2837 90.3262 45.2837ZM107.665 32.5733H108.287V45.2114H107.665V32.5733ZM98.6835 45.2114H98.0615V32.5733H98.6835V45.2114ZM107.775 39.0729H98.5742V38.5132H107.775V39.0729ZM112.978 45.2114V32.5733H113.6V44.6518H121.1V45.2114H112.978ZM121.411 45.2114L127.339 32.5733H127.942L133.869 45.2114H133.193L127.503 32.9886H127.778L122.089 45.2114H121.411ZM123.462 41.5102L123.699 40.9867H131.527L131.766 41.5102H123.462ZM136.362 45.2114V32.5733H136.874L146.276 44.4893H145.966V32.5733H146.588V45.2114H146.075L136.673 33.2956H136.984V45.2114H136.362ZM151.278 45.2114V32.5733H156.217C157.582 32.5733 158.772 32.8502 159.784 33.4038C160.796 33.9455 161.582 34.6917 162.143 35.6426C162.716 36.5814 163.003 37.6647 163.003 38.8924C163.003 40.1201 162.716 41.2094 162.143 42.1603C161.582 43.099 160.796 43.8453 159.784 44.399C158.772 44.9406 157.582 45.2114 156.217 45.2114H151.278ZM151.9 44.6518H156.18C157.436 44.6518 158.527 44.405 159.454 43.9116C160.393 43.418 161.113 42.7379 161.612 41.8713C162.126 41.0048 162.382 40.0118 162.382 38.8924C162.382 37.7729 162.126 36.78 161.612 35.9134C161.113 35.0468 160.393 34.3667 159.454 33.8733C158.527 33.3797 157.436 33.133 156.18 33.133H151.9V44.6518Z"
              fill="#304036"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1413_2214"
                x1="25.5016"
                y1="-3.98877"
                x2="16.1808"
                y2="34.3776"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.0001" />
                <stop offset="0.0002" stop-color="white" />
                <stop offset="0.302083" stop-color="#5F6C5A" />
                <stop offset="1" stop-color="#184941" />
              </linearGradient>
            </defs>
          </svg> */}
        </div>
        <div className="weoprologin-mx">
          <img src={Logo} width={200} height={100}/>
        </div>
        <div
          className="login-form login-signin login-width"
          id="kt_login_signin_form"
        >
          <div className="text-center mb-10 mb-lg-20"></div>
          <div className="text-center mb-10 mb-lg-20 new-design">
            <h3 className="font-size-h1">Anmelden</h3>
            <p className=" font-weight-bold new-under-design">
              Voico
            </p>
            <span className="text-danger h6">{errors.user}</span>
          </div>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
          />
          <form onSubmit={onFormSubmit}>
            <div
              className="form-group fv-plugins-icon-container"
              style={{ border: "1px solid #41624C", borderRadius: "5px" }}
            >
              <div className="input-alignment input-alignment-sc">
                <input
                  placeholder="Email"
                  type="email"
                  className={`email-input-sc form-control form-control-solid h-auto py-5`}
                  name="emailId"
                  style={{
                    width: "398px",
                    height: "52px",
                    outline: "none",
                    background: "transparent",
                  }}
                  value={loginData?.emailId}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                />
              </div>
            </div>
            <span className="text-danger">{errors.emailId}</span>
            <div
              className="d-flex align-items-center form-control form-control-lg form-control-solid  input-alignment form-inp-sc"
              style={{
                height: "52px",
                border: "1px solid #41624C",
                borderRadius: "5px",
                paddingLeft: "11px",
                marginBottom: "9px",
                marginTop: "5px",
                background: "transparent",
              }}
            >
              <input
                style={{
                  outline: "none",
                  width: "382px",
                  background: "transparent",
                }}
                type={showPassword ? "text" : "password"}
                className="w-100 bg-transparent border border-transparent h-100 "
                name="password"
                placeholder="Passwort"
                onChange={handleChange}
              />
              <div className="cursor-pointer">
                {showPassword ? (
                  <i
                    className="fa fa-eye-slash"
                    aria-hidden="true"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ fontSize: "20px" }}
                  ></i>
                ) : (
                  <i
                    className="fa fa-eye"
                    aria-hidden="true"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ fontSize: "20px" }}
                  ></i>
                )}
              </div>
            </div>
            <span className="text-danger">{errors.password}</span>
            <div
              style={{ opacity: "1" }}
              className="form-group d-flex flex-wrap justify-content-center align-items-center "
            >
              <button
                id="kt_login_signin_submit"
                type="submit"
                className={`align-items-center d-flex btn btn  font-weight-bold my-15 new-class-design `}
                onClick={(e) => {
                  handleSubmit(e);
                }}
                style={{ background: "#FFDF5C", opacity: "1" }}
              >
                <span className=" new-class-desig-vddwsas">Einloggen</span>
                {bool.loader && (
                  <div class="spinner-border text-dark" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                )}
              </button>
            </div>
          </form>
        </div>
        {/* <div className="login-page-skatch-image-div">
          <img src={weprologinskatch} />
        </div> */}
      </div>
    </>
  );
}
